import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';
import { EventType } from 'src/app/core/models/EventType';
import { CustomerStories, CustomerStory } from './customer-story.data';
@Component({
    selector: 'qo-customer-story',
    templateUrl: './customer-story.component.html',
    imports: [CommonModule, RouterModule, MatRippleModule]
})
export class CustomerStoryComponent {

    @Input() compact: boolean = false;
    @Input() type?: EventType;
    @Input() quantity: number = 1;
    @Input() story?: CustomerStory;
    @Input() theme: string = 'primary';

    stories: CustomerStory[] = [];

    constructor() {  
    }

    ngOnInit(): void {
      if(this.story) {
        this.stories.push(this.story);
      } else {
        this.stories = CustomerStories
            .filter(x => !this.type || x.types.includes(this.type))
            .map(x => ({ value: x, random: Math.random() }))
            .sort((a,b) => a.random - b.random)
            .map(x => x.value)
            .slice(0, this.quantity);
      }
    }
}